import React, { useState } from 'react';
import { InstagramIcon, FacebookIcon, YoutubeIcon, MailIcon, HeartIcon, SparklesIcon } from 'lucide-react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsAndConditions } from './TermsAndConditions';
import { ContactForm } from './ContactForm';
import { SupportContent } from './SupportContent';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'contact' | 'support' | null>(null);
  return <>
      <footer className="bg-gradient-to-br from-baby-pink-light via-baby-cream to-baby-blue-light relative overflow-hidden" data-id="element-463">
        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-40 h-40 bg-baby-pink/20 rounded-full blur-3xl animate-float-slow" data-id="element-464"></div>
        <div className="absolute bottom-0 right-0 w-48 h-48 bg-baby-blue/20 rounded-full blur-3xl animate-float" data-id="element-465"></div>
        <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-baby-lavender/20 rounded-full blur-3xl" data-id="element-466"></div>

        <div className="max-w-6xl mx-auto px-4 py-12 sm:py-16 relative" data-id="element-467">
          {/* Newsletter Section - Featured */}
          <div className="mb-12 sm:mb-16" data-id="element-468">
            <div className="bg-white/90 backdrop-blur-baby rounded-baby-lg p-8 sm:p-10 shadow-baby-glow border-2 border-baby-lavender max-w-3xl mx-auto text-center" data-id="element-469">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-baby-gradient-pink-blue rounded-full mb-5 animate-soft-pulse" data-id="element-470">
                <SparklesIcon className="w-8 h-8 text-white" data-id="element-471" />
              </div>
              <h3 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-3" data-id="element-472">
                ¡Únete a Nuestra Comunidad! 🍼
              </h3>
              <p className="text-gray-700 text-base sm:text-lg mb-6 max-w-xl mx-auto" data-id="element-473">
                Recibe recetas exclusivas, tips de alimentación y contenido
                especial para tu bebé
              </p>
              <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-id="element-474">
                <input type="email" placeholder="tu@email.com" className="flex-1 px-5 py-3.5 rounded-baby border-2 border-baby-blue-light focus:border-baby-blue focus:outline-none focus:ring-2 focus:ring-baby-blue/20 text-gray-900 text-base" data-id="element-475" />
                <button className="bg-baby-gradient-pink-blue text-white px-8 py-3.5 rounded-baby font-extrabold hover:shadow-baby-glow transition-all text-base whitespace-nowrap" data-id="element-476">
                  SUSCRIBIRME ✨
                </button>
              </div>
            </div>
          </div>

          {/* Simplified Footer Links - 2 Columns Only */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mb-12 max-w-2xl mx-auto" data-id="element-477">
            {/* Ayuda */}
            <div className="bg-white/80 backdrop-blur-baby rounded-baby-lg p-6 sm:p-8 border-2 border-baby-pink-light shadow-baby-soft" data-id="element-478">
              <h4 className="font-extrabold mb-5 text-lg sm:text-xl text-gray-900 flex items-center gap-2" data-id="element-479">
                <span className="text-2xl" data-id="element-480">💬</span> Ayuda & Soporte
              </h4>
              <ul className="space-y-3.5 text-sm sm:text-base" data-id="element-481">
                <li data-id="element-482">
                  <a href="#" className="text-gray-800 hover:text-baby-pink transition font-semibold flex items-center gap-2 group" data-id="element-483">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-484">
                      →
                    </span>{' '}
                    Preguntas Frecuentes
                  </a>
                </li>
                <li data-id="element-485">
                  <button onClick={() => setActiveModal('support')} className="text-gray-800 hover:text-baby-pink transition font-semibold flex items-center gap-2 text-left group" data-id="element-486">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-487">
                      →
                    </span>{' '}
                    Centro de Soporte
                  </button>
                </li>
                <li data-id="element-488">
                  <button onClick={() => setActiveModal('contact')} className="text-gray-800 hover:text-baby-pink transition font-semibold flex items-center gap-2 text-left group" data-id="element-489">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-490">
                      →
                    </span>{' '}
                    Contacto
                  </button>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div className="bg-white/80 backdrop-blur-baby rounded-baby-lg p-6 sm:p-8 border-2 border-baby-blue-light shadow-baby-soft" data-id="element-491">
              <h4 className="font-extrabold mb-5 text-lg sm:text-xl text-gray-900 flex items-center gap-2" data-id="element-492">
                <span className="text-2xl" data-id="element-493">⚖️</span> Legal
              </h4>
              <ul className="space-y-3.5 text-sm sm:text-base" data-id="element-494">
                <li data-id="element-495">
                  <button onClick={() => setActiveModal('terms')} className="text-gray-800 hover:text-baby-blue transition font-semibold flex items-center gap-2 text-left group" data-id="element-496">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-497">
                      →
                    </span>{' '}
                    Términos y Condiciones
                  </button>
                </li>
                <li data-id="element-498">
                  <button onClick={() => setActiveModal('privacy')} className="text-gray-800 hover:text-baby-blue transition font-semibold flex items-center gap-2 text-left group" data-id="element-499">
                    <span className="group-hover:translate-x-1 transition-transform" data-id="element-500">
                      →
                    </span>{' '}
                    Política de Privacidad
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Links - Enhanced */}
          <div className="mb-10" data-id="element-501">
            <p className="text-center text-gray-700 font-bold mb-5 text-sm sm:text-base" data-id="element-502">
              Síguenos en Redes Sociales 💕
            </p>
            <div className="flex justify-center gap-4" data-id="element-503">
              <a href="https://www.instagram.com/kiosscodigital/" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-white/90 backdrop-blur-baby rounded-full flex items-center justify-center text-baby-pink hover:bg-baby-gradient-pink-blue hover:text-white transition-all shadow-baby-soft border-2 border-baby-pink-light hover:scale-110 hover:shadow-baby-glow" data-id="element-504">
                <InstagramIcon className="w-6 h-6" data-id="element-505" />
              </a>
              <a href="https://www.facebook.com/contactokd" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-white/90 backdrop-blur-baby rounded-full flex items-center justify-center text-baby-blue hover:bg-baby-gradient-blue hover:text-white transition-all shadow-baby-soft border-2 border-baby-blue-light hover:scale-110 hover:shadow-baby-glow" data-id="element-506">
                <FacebookIcon className="w-6 h-6" data-id="element-507" />
              </a>
              <a href="https://www.youtube.com/channel/UC8lSBB0QudahrVjqA8b6xyA" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-white/90 backdrop-blur-baby rounded-full flex items-center justify-center text-baby-pink hover:bg-baby-gradient-pink hover:text-white transition-all shadow-baby-soft border-2 border-baby-pink-light hover:scale-110 hover:shadow-baby-glow" data-id="element-508">
                <YoutubeIcon className="w-6 h-6" data-id="element-509" />
              </a>
            </div>
          </div>

          {/* Copyright - Enhanced */}
          <div className="text-center border-t-2 border-baby-lavender pt-8" data-id="element-510">
            <p className="text-gray-700 text-xs sm:text-sm mb-4 px-4 font-medium max-w-2xl mx-auto" data-id="element-511">
              Los resultados pueden variar según la consistencia de
              implementación del sistema. Consulta con un pediatra antes de
              introducir nuevos alimentos.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-gray-900 font-bold text-sm sm:text-base" data-id="element-512">
              <span data-id="element-513">© 30 Recetas para Bebés</span>
              <span className="hidden sm:inline" data-id="element-514">•</span>
              <span className="flex items-center gap-2" data-id="element-515">
                Hecho con{' '}
                <HeartIcon className="w-4 h-4 text-baby-pink fill-baby-pink animate-soft-pulse" data-id="element-516" />{' '}
                para tu bebé
              </span>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-517">
        <PrivacyPolicy data-id="element-518" />
      </Modal>
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-519">
        <TermsAndConditions data-id="element-520" />
      </Modal>
      <Modal isOpen={activeModal === 'contact'} onClose={() => setActiveModal(null)} title="Contacto" data-id="element-521">
        <ContactForm data-id="element-522" />
      </Modal>
      <Modal isOpen={activeModal === 'support'} onClose={() => setActiveModal(null)} title="Centro de Soporte" data-id="element-523">
        <SupportContent data-id="element-524" />
      </Modal>
    </>;
}